import { defineMessages } from 'react-intl';

export default defineMessages({
  savingsInsight: {
    defaultMessage: 'Savings insight',
    id: 'PKNsKP',
    description: 'Savings insight',
  },
  savingsDisclaimer: {
    defaultMessage: '*Savings are calculated based on the last 30 days of shipping activity.',
    id: 'duV+VM',
    description: 'Disclaimer stating how savings are calculated.',
  },
  description: {
    defaultMessage: '<b>You could have saved {currency}</b> when switching from {fromServiceName} to {toServiceName} from ShipStation.',
    id: 'ERomPA',
    description: 'Telling the user how much money they will save for enabling an automation rule.',
  },
  saveExplanationLink: {
    defaultMessage: 'See how we calculated this',
    id: '+4mwZK',
    description: 'Link to open a modal to explain how the savings were calculated',
  },
  modalTitle: {
    defaultMessage: 'Here are ways you could save. Automate these savings by setting up Automated Rate Shoppers.',
    id: 'EXJJqI',
    description: 'Title of the modal showing the automation rule recommendations to save money',
  },
  saveButton: {
    defaultMessage: 'Unlock Future Savings with an Expert',
    id: 'd/ZbXa',
    description: 'Call to Action for having the user contact sales to set up automation rules',
  },
  disabledButtonMessage: {
    defaultMessage: 'Your request has been submitted. An expert will reach out within the next business day to schedule a call.',
    id: 'gWC98N',
    description: 'Message that shows when CTA is disabled for contacting sales to set up automation rules',
  },
});
